import React from 'react';

const TaxbillAddPage = () => {
  return <div></div>;
};

export default TaxbillAddPage;
